import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';
import styles from './styles';
import EirOrderedOfferType from '../eir-order-summary/EirOrderdOfferType';
import PrepayCartInfo from '../eir-prepay/prepay-summary/PrepayCartInfo';

const EirCartDetails = ({
  cartData,
  loading,
  deleteIcon,
  summaryData,
  missingStep,
  tacticalOffers,
  isCartDoc,
}) => {
  const theme = useTheme();
  const [hasMissingStep, setHasMissingStep] = useState(false);
  console.log(hasMissingStep);

  return (
    <Grid container sx={styles(theme).container}>
      <Grid item xs={6} sm={6} sx={styles(theme).monthlyCostContainer}>
        <Typography variant='h2' sx={styles(theme).cartTitle}>
          {summaryData?.summary?.title?.cartTitle}
        </Typography>
        {cartData?.offerType === 'PREPAY' ? (
          <PrepayCartInfo
            cartData={cartData}
            deleteIcon={deleteIcon}
            summaryData={summaryData}
            isCartDoc={isCartDoc}
            loading={loading}
          />
        ) : (
          <EirOrderedOfferType
            tacticalOffers={tacticalOffers}
            isCartDoc={isCartDoc}
            summaryData={summaryData}
            cartData={cartData}
            loading={loading}
            deleteIcon={deleteIcon}
            missingStep={missingStep}
            setHasMissingStep={setHasMissingStep}
          />
        )}
      </Grid>
    </Grid>
  );
};
export default EirCartDetails;
